const Routes = {
  ROOT: '/',
  LOGBOOK: '/logbook',
  REPORTS: '/reports',
  ORG_LIST: '/organization-list',
  OVERVIEW: '/overview',
  COMPANY: 'settings/general/company',
};

export default Routes;
